import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { LoadingBackdrop } from 'components/common'
import {
  CreateAndUpdateCancellationOrLostReasonDtoInput,
  useGetCancellationOrLostReasonQuery,
} from 'generated/graphql'

import CancellationOrLostReasonsForm from './CancellationOrLostReasonsForm'

interface IProps {
  id: number
  mode: number | undefined
}

const UpdateCancellationOrLostReasons = (props: IProps) => {
  const { id, mode } = props
  const { reset } = useFormContext<CreateAndUpdateCancellationOrLostReasonDtoInput>()

  const { data, loading } = useGetCancellationOrLostReasonQuery({
    variables: { id },
  })

  useEffect(() => {
    if (data?.cancellationOrLostReason) {
      const { __typename, ...rest } = data.cancellationOrLostReason
      reset({ ...rest })
    }
  }, [data, reset])

  return (
    <>
      <CancellationOrLostReasonsForm mode={mode} />
      <LoadingBackdrop loading={loading} />
    </>
  )
}

export default UpdateCancellationOrLostReasons
